import { render, staticRenderFns } from "./NoteAddButton.vue?vue&type=template&id=951b55d2"
import script from "./NoteAddButton.vue?vue&type=script&lang=js"
export * from "./NoteAddButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports